// src/api/urls.js
export const API_BASE_URL = 'https://at.aiaxc.com/api';

export const API_ENDPOINTS = {
  //注册、登录
  login: `${API_BASE_URL}/login.php`,
  english: `${API_BASE_URL}/english.php`,
  info: `${API_BASE_URL}/info.php`,
  feedback: `${API_BASE_URL}/feedback.php`,
  collection: `${API_BASE_URL}/collection.php`,
  // 其他接口...

};
